import { render } from "./ProsesRumah.vue?vue&type=template&id=565ea00c"
import script from "./ProsesRumah.vue?vue&type=script&lang=js"
export * from "./ProsesRumah.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__